import Axios from 'axios';
import UrlHelper from '../Helpers/urlHelper';

class SchoolService {

    async sendWork(data) {
        const response = await Axios.post(
            UrlHelper.buildSchoolWorkUrl(),
            JSON.stringify(data)
        );
        return response.data;
    }

    async search(data) {
        const response = await Axios.post(
            UrlHelper.buildSchoolWorkSearchUrl(),
            JSON.stringify(data)
        );
        return response.data
    }
}

export default SchoolService;